import DragItem from "../../ddTxtImg/model/DragItem";
import DragWordToImgActivity from "../../ddTxtImg/model/DragWordToImgActivity";
import WordOnImgDropItemContainer from "./WordOnImgDropItemContainer";





class WordOnImgActvity extends DragWordToImgActivity {


    constructor() {
        super()
        this.activityType = this.WORD_ON_IMG
        this.dropItemContainer = new WordOnImgDropItemContainer()
        this.imgUrl = "http://s3.amazonaws.com/cdn.testengine.com/CONTENT/DRAG_DROP/"
    }



    resetActivity = () => {
        this.answeredTrue = true;

        let { dropItemList } = this.dropItemContainer

        for (let i = 0; i < dropItemList.length; i++) {
            dropItemList[i].solvedDragItem = new DragItem();
            dropItemList[i].dropTxt = "........"
            if (dropItemList[i].solvedDragItemHtml != null)
                dropItemList[i].solvedDragItemHtml.style.display = "inline-block"
        }

    }

    initFromJson = (obj) => {

        this.initPublicItemsFromJson(obj)
        this.dragContainerModel.initFromJson(obj.dragContainerModel)


        this.dropItemContainer.initFromJson(obj.dropItemContainer)


    }

    getAsJson = () => {


        let jsCode = this.getPublicItemsAsJson();
        jsCode.dragContainerModel = this.dragContainerModel.getAsJson()

        jsCode.dropItemContainer = this.dropItemContainer.getAsJson()

        return jsCode
    }

    getReportAsJson = () => {

        let jsCode = {}
        jsCode.activityId = this.activityId
        jsCode.dropItemContainer = this.dropItemContainer.getReportAsJson()
        jsCode.answeredTrue = this.answeredTrue
        jsCode.activityType = this.activityType
        jsCode.isSkipped = this.isSkipped
        return jsCode
    }

    initReportFromJson = (obj) => {

        this.activityId = obj.activityId
        this.dropItemContainer = new WordOnImgDropItemContainer()
        this.dropItemContainer.initReportFromJson(obj.dropItemContainer)
        this.answeredTrue = obj.answeredTrue
        this.isSkipped = obj.isSkipped
    }


    initSharedItems = (activityArr) => {
        this.initPublicSharedItem(activityArr);
    }

    initFromJsonTest4You = (obj) => {

        this.initPublicItemsFromJsonTest4You(obj)

        this.readText.initFromJsonTest4You(obj.readTextObj)
        this.dragContainerModel.initFromJsonTest4You(obj.dragContainerModel)
        this.dropItemContainer.initFromJsonTest4You(obj.dropItemContainer, this.dragContainerModel.dragItemList)
    }
    getAnsweredTrue = () => {
        let { dropItemList } = this.dropItemContainer
        dropItemList.forEach(dropItem => {
            let isTrue = false
            for (let i = 0; i < dropItem.dragList.length; i++) {
                if (dropItem.solvedDragItem.dragIndex == dropItem.dragList[i].dragIndex) {
                    isTrue = true
                    break
                }
            }


            if (!isTrue)
                this.answeredTrue = false
        });
        //    


        this.isSkipped = true
        dropItemList.forEach(dropItem => {
            if (dropItem.solvedDragItem != null && dropItem.solvedDragItem.dragIndex != -1) {
                this.isSkipped = false
            }
        })
    }
}

export default WordOnImgActvity